import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Stack, Typography } from "@mui/material";
import { patchInvestigation } from "../../../../../apis";
import { InvestigationAdvertisement } from "../components/InvestigationAdvertisement";
import { InvestigationSectionHeader } from "../components/InvestigationSectionHeader";
import { AddInterview } from "./AddInterview";
import { SingleInterview } from "./SingleInterview";
import { Separator } from "../components";
import { useConstants } from "../Main/useConstants";

export const Interviews = ({
  reportDetail,
  investigation,
  setInvestigation,
  justView = false,
  handleSelectedSection,
  openConfirmDeleteModal,
  closeModalConfirm,
  onReload,
}) => {
  const [t] = useTranslation("investigation");
  const { enums } = useConstants();

  const [interviews, setInterviews] = useState(investigation.interviews ?? []);

  // Selected interview for edition
  const [selectedInterview, setSelectedInterview] = useState(null);
  // Is editing intweview form?
  const [isAdding, setIsAdding] = useState(false);

  const someInterviewExist = useMemo(() => {
    if (interviews.length > 0) return true;
    return false;
  }, [interviews]);

  useEffect(() => {
    if (investigation.interviews != null) {
      setInterviews(investigation.interviews);
    } else {
      setInterviews([]);
    }
  }, [investigation?.interviews]);

  const handleSaveInterviews = async (interviews) => {
    const objToSave = {
      folder: {
        interviews,
      },
    };

    try {
      await patchInvestigation(investigation.alias, objToSave);
      setInvestigation({ ...investigation, interviews });
      setSelectedInterview(null);
      setIsAdding(false);
    } catch (error) {
      console.error(error);
    }
  };

  if (!someInterviewExist && justView) return null;

  return (
    <Box className="dyTheme1">
      {!isAdding && !justView && (
        <InvestigationSectionHeader
          text={t("Agrega entrevistas a la investigación del reporte")}
          buttonText={t("AGREGAR ENTREVISTA")}
          buttonIcon="outline_messages_3"
          onClick={() => setIsAdding(true)}
        />
      )}

      {!someInterviewExist && !isAdding && !justView && (
        <InvestigationAdvertisement
          title={t("Sin entrevistas cargadas")}
          description={t(
            "En esta sección puedes generar, documentar y calificar entrevistas que respalden tu investigación."
          )}
        />
      )}

      {someInterviewExist && justView && (
        <Separator
          text={t("Entrevistas")}
          icon="outline_messages_3"
          iconButton="outline_edit"
          onClick={() => handleSelectedSection(enums.sections.interviews)}
          sx={{ marginBottom: 1.5 }}
        />
      )}

      {someInterviewExist && !isAdding && (
        <Stack padding={justView ? 0 : 2} spacing={2}>
          {interviews.map((interview, idx) => (
            <SingleInterview
              key={idx}
              idx={idx}
              interview={interview}
              interviews={interviews}
              setInterviews={setInterviews}
              setSelectedInterview={setSelectedInterview}
              handleSaveInterviews={handleSaveInterviews}
              openConfirmDeleteModal={openConfirmDeleteModal}
              closeModalConfirm={closeModalConfirm}
              setIsAdding={setIsAdding}
              justView={justView}
              alias={investigation.alias ?? ""}
              onReload={onReload}
            />
          ))}
        </Stack>
      )}
      {isAdding && (
        <AddInterview
          interviews={interviews}
          selectedInterview={selectedInterview}
          setSelectedInterview={setSelectedInterview}
          setIsAdding={setIsAdding}
          handleSaveInterviews={handleSaveInterviews}
          alias={investigation.alias}
          onReload={onReload}
        />
      )}
    </Box>
  );
};
